import { _uniqueName } from "./utils";
import { Notification } from "./Notification";
import { UIWidgetGroup } from "./UiWidgetGroup";

export function ApplicationUI(pData) {
  Notification.call(this);

  this.mTabs = [];
  this.mSelectedTab = undefined;
  this.mIsReadonly = false;
  this.mUseFullUiSpace = false;

  if (pData) {
    this.fromJson(pData);
  }

  // Note (mkosarek) Ensure that there is always at least one primary tab
  if (this.mTabs.length == 0) {
    this.mTabs.push(new UIWidgetGroup({ name: 'Group 1' }));
  }
}

ApplicationUI.prototype = Object.create(Notification.prototype);
ApplicationUI.prototype.getName = function() { return 'UI'; };

ApplicationUI.prototype.isEmpty = function() { return this.listTabs().every((pTab) => pTab.listWidgets().length == 0); };

ApplicationUI.prototype.uniqueTabName = function(pTabName) {
  return _uniqueName(pTabName, this.mTabs.map(function(pTab) { return pTab.name; }));
};

ApplicationUI.prototype.addTab = function() {
  const lTabIndex = this.mTabs.length;
  const lTabName = this.uniqueTabName('Group ' + (this.mTabs.length + 1));
  const lTab = new UIWidgetGroup({ name: lTabName });

  this.mTabs.push(lTab);
  this.notify('onTabAdded', lTab, lTabIndex);

  return { tab: lTab, index: lTabIndex };
};

ApplicationUI.prototype.removeTab = function(pTabIndex) {
  if (pTabIndex < 0 || pTabIndex >= this.mTabs.length) {
    console.error('Tab does not exist', pTabIndex);
    return;
  }

  const lRemovedTab = this.mTabs[pTabIndex];
  this.mTabs.splice(pTabIndex, 1);
  this.notify('onTabRemoved', lRemovedTab, pTabIndex);
};

ApplicationUI.prototype.selectTab = function(pTabIndex) {
  if (pTabIndex < 0 || pTabIndex >= this.mTabs.length) {
    console.error('Tab does not exist', pTabIndex);
    return;
  }

  this.mSelectedTab = this.mTabs[pTabIndex];
  this.notify('onTabSelected', this.mSelectedTab);
};

ApplicationUI.prototype.getSelectedTab = function() { return this.mSelectedTab; };

ApplicationUI.prototype.listTabs = function() {
  return this.mTabs;
};

ApplicationUI.prototype.listAllWidgets = function() {
  const lWidgets = [];
  this.mTabs.forEach(function(pTab){
    lWidgets.push(...pTab.listWidgets());
  });
  return lWidgets;
};

ApplicationUI.prototype.scaleAllWidgets = function(widthMultiplier, heightMultiplier) {
  this.mTabs.forEach(tab => {
    tab.listWidgets().forEach(widget => {
      widget.mStyles.height = `${parseInt(widget.mStyles.height.split('px')[0]) * heightMultiplier}px`;
      widget.mStyles.top = `${parseInt(widget.mStyles.top.split('px')[0]) * heightMultiplier}px`;
      widget.mStyles.width = `${parseInt(widget.mStyles.width.split('px')[0]) * widthMultiplier}px`;
      widget.mStyles.left = `${parseInt(widget.mStyles.left.split('px')[0]) * widthMultiplier}px`;
    });
  });
};

ApplicationUI.prototype.getTabByIndex = function(pIndex) {
  if (pIndex < 0 || pIndex >= this.mTabs.length) {
    console.error('Tab index invalid: ' + pIndex);
    return undefined;
  }

  return this.mTabs[pIndex];
};
ApplicationUI.prototype.getTabByName = function(pName) {
  return this.mTabs.find(function(pTab) { return pTab.mName === pName; });
};

ApplicationUI.prototype.setIsReadonly = function(pIsReadonly) {
  this.mIsReadonly = pIsReadonly;
};

ApplicationUI.prototype.isReadonly = function() {
  return this.mIsReadonly;
};

ApplicationUI.prototype.useFullUiSpace = function() {
  return this.mUseFullUiSpace;
};

ApplicationUI.prototype.setUseFullUiSpace = function(pUseFullUiSpace) {
  this.mUseFullUiSpace = pUseFullUiSpace;
};

ApplicationUI.prototype.fromJson = function(pJson) {
  this.mTabs = pJson.tabs.map(function(pJsonTab) {
    return new UIWidgetGroup(pJsonTab);
  });
  this.mIsReadonly = pJson.isReadonly || false;
  this.mUseFullUiSpace = pJson.useFullUiSpace || false;
};

ApplicationUI.prototype.toJson = function() {
  return {
    tabs: this.mTabs.map(function(mTab) {
      return mTab.toJson();
    }),
    isReadonly: this.mIsReadonly,
    useFullUiSpace: this.mUseFullUiSpace
  };
};
